import { Dispatch, FC, SetStateAction } from 'react';
import { Filter, LogicalOperator } from 'utils/rsql-util';
import { DataTableColumn } from '../data-table';

export type FiltersControlProps = {
  filters: any[];
  columns: DataTableColumn[];
  handleAddFilter: () => any;
  handleRemoveFilter: (index: number) => any;
  handleFilterUpdate: (filter: Filter, index: number) => any;
  logicalOperator: LogicalOperator;
  setLogicalOperator: Dispatch<SetStateAction<LogicalOperator>>;
  getFilterOperators: (filter: Filter, index: number) => any;
  getFilterValueComponent: (filter: Filter, index: number) => any;
};

export const FiltersControl: FC<FiltersControlProps> = ({
  filters,
  columns,
  handleAddFilter,
  handleRemoveFilter,
  handleFilterUpdate,
  logicalOperator,
  setLogicalOperator,
  getFilterOperators,
  getFilterValueComponent
}) => {
  return (
    <>
      <div className="d-flex justify-content-between text-uppercase">
        <h4>Filters</h4>
      </div>
      <p className="white-space-nowrap">To add a filter, please select the 'Add Filter' button.</p>
      <div>
        <div className="d-flex justify-content-between g-3 mt-3">
          <div className="d-flex align-items-center g-1">
            <span>OR</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={logicalOperator === LogicalOperator.AND}
                onChange={e =>
                  e.target.checked ? setLogicalOperator(LogicalOperator.AND) : setLogicalOperator(LogicalOperator.OR)
                }
                data-cy="logical-operator-switch"
              />
              <span className="slider round" />
            </label>
            <span>AND</span>
          </div>
          <button className="btn-outline" onClick={() => handleAddFilter()} data-cy="add-filter-button">
            Add Filter
          </button>
        </div>
        {filters.map((f, i) => {
          return (
            <div className="d-flex g-3 mb-3 mt-3" key={i}>
              <select
                value={f.field}
                onChange={event => handleFilterUpdate({ ...f, field: event.target.value }, i)}
                data-cy="filter-field-select"
              >
                {columns
                  .filter(c => c.filterable !== false)
                  .map(c => {
                    return (
                      <option key={c.field} value={c.field}>
                        {c.label}
                      </option>
                    );
                  })}
              </select>
              {getFilterOperators(f, i)}
              {getFilterValueComponent(f, i)}
              <button
                className="icon-button"
                onClick={() => handleRemoveFilter(i)}
                data-cy={`filter-${i}-delete-button`}
              >
                <span className="material-icons">close</span>
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
};
